(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-studio-hero]').forEach(hero => {
      if (hero.dataset.studioReady) return;
      hero.dataset.studioReady = 'true';
      const video = hero.querySelector('video');
      const toggle = hero.querySelector('.studio-video-toggle');
      if (!video || !toggle) return;
      video.setAttribute('aria-hidden', 'true');
      video.setAttribute('tabindex', '-1');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const sync = () => {
        toggle.setAttribute('aria-label', video.paused ? toggle.dataset.play : toggle.dataset.pause);
        toggle.setAttribute('aria-pressed', String(!video.paused));
        toggle.querySelector('[data-video-icon]').textContent = video.paused ? '▶' : 'Ⅱ';
      };
      const play = () => video.play().catch(sync);
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      toggle.addEventListener('click', () => video.paused ? play() : video.pause());
      motion.addEventListener('change', () => { if (motion.matches) video.pause(); });
      if (!motion.matches && !navigator.connection?.saveData) play();
      sync();
    });
    scope.querySelectorAll('.studio-products').forEach(section => {
      if (section.dataset.studioReady) return;
      section.dataset.studioReady = 'true';
      const move = step => {
        const rail = section.querySelector('[data-pack-panel]:not([hidden]) [data-studio-rail]') || section.querySelector('[data-studio-rail]');
        const card = rail?.querySelector('.studio-card');
        if (!rail || !card) return;
        const direction = getComputedStyle(rail).direction === 'rtl' ? -1 : 1;
        const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
        rail.scrollBy({left: step * direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      section.querySelector('[data-rail-prev]').addEventListener('click', () => move(-1));
      section.querySelector('[data-rail-next]').addEventListener('click', () => move(1));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
